module.exports = "https://static.wmbcdn.com/uniweb/images/e6e3709bfcefa6c7440d25a6f2394441.svg";